import { useHandleAnalytics } from "../lib/analytics";
import { AnalyticEvents, AnalyticsBet } from "@fresh8/types/src/analytics";
import { usePixelMacros } from "../composition/pixelMacros";

export const useAnalytics = (
  props: {
    marketId?: string;
    eventId?: string;
    optionId?: string;
    betSelections?: {
      eventId: string;
      marketId: string;
      optionId: string;
    }[];
  },
  statsDesc: string
): {
  handleClick: () => void;
  handleViewed: (bets: AnalyticsBet[]) => void;
} => {
  const { getPixelUrl, getPixelMacroData, populatePixelUrl } = usePixelMacros();
  const $handleAnalytics = useHandleAnalytics();

  const handleClick = () => {
    const statsEvent = AnalyticEvents.CLICKED_THROUGH;
    let pixelData;
    let bets;

    const betSelections = props.betSelections;
    const hasMultipleAnalyticElements = !!betSelections && !!betSelections.length;

    if (betSelections && hasMultipleAnalyticElements) {
      pixelData = getPixelMacroData(betSelections[0]);
      bets = betSelections.map(selection => ({
        betOptionID: selection.optionId,
        betID: selection.marketId
      }));
    } else {
      pixelData = getPixelMacroData(props);
      bets =
        props.optionId && props.marketId
          ? [
              {
                betOptionID: props.optionId,
                betID: props.marketId
              }
            ]
          : [];
    }
    //TODO: check for type
    const pixelUrl = getPixelUrl(statsEvent);

    $handleAnalytics(
      statsEvent,
      statsDesc,
      bets,
      pixelUrl
        ? pixelData
          ? populatePixelUrl(pixelData, pixelUrl)
          : pixelUrl.split("?")[0]
        : undefined
    );
  };

  const handleViewed = (bets: AnalyticsBet[]) => {
    const statsEvent = AnalyticEvents.VIEWED;
    const pixelUrl = getPixelUrl(statsEvent);

    $handleAnalytics(statsEvent, statsDesc, bets, pixelUrl);
  };

  return { handleClick, handleViewed };
};

//TODO: make Pixels work with multiple selections
